import { Box, BoxProps } from "@chakra-ui/react";

function DefaultSearchIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="57"
        height="56"
        viewBox="0 0 57 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7695 46.6666C12.6954 46.6666 11.7986 46.3069 11.0792 45.5875C10.3597 44.868 10 43.9713 10 42.8971V13.1028C10 12.0287 10.3597 11.1319 11.0792 10.4125C11.7986 9.69304 12.6954 9.33331 13.7695 9.33331H43.5638C44.6379 9.33331 45.5347 9.69304 46.2542 10.4125C46.9736 11.1319 47.3333 12.0287 47.3333 13.1028V42.8971C47.3333 43.9713 46.9736 44.868 46.2542 45.5875C45.5347 46.3069 44.6379 46.6666 43.5638 46.6666H13.7695ZM13.7695 44.3333H43.5638C43.9232 44.3333 44.2524 44.1838 44.5514 43.8847C44.8505 43.5857 45 43.2565 45 42.8971V13.1028C45 12.7435 44.8505 12.4143 44.5514 12.1152C44.2524 11.8162 43.9232 11.6666 43.5638 11.6666H13.7695C13.4102 11.6666 13.081 11.8162 12.7819 12.1152C12.4829 12.4143 12.3333 12.7435 12.3333 13.1028V42.8971C12.3333 43.2565 12.4829 43.5857 12.7819 43.8847C13.081 44.1838 13.4102 44.3333 13.7695 44.3333ZM20.0514 38.5H37.6412C38.0181 38.5 38.2932 38.331 38.4667 37.9931C38.6401 37.6551 38.6162 37.3214 38.3949 36.9921L33.6833 30.6611C33.4799 30.4095 33.2287 30.2837 32.9297 30.2837C32.6302 30.2837 32.3788 30.4095 32.1754 30.6611L26.8268 37.4231L23.4972 33.3981C23.2938 33.1769 23.0501 33.0662 22.7662 33.0662C22.482 33.0662 22.2381 33.1918 22.0347 33.4431L19.3421 36.9921C19.0909 37.3214 19.052 37.6551 19.2254 37.9931C19.3992 38.331 19.6746 38.5 20.0514 38.5Z"
          fill="#2563EB"
        />
      </svg>
    </Box>
  );
}

export { DefaultSearchIcon };
